import styled from 'styled-components';

import { HEADER_HEIGHT } from '@/core/components/Layout/Layout.styles';

export const PANEL_WIDTH = '339px';

export const PanelWrapper = styled.div<{ isOpen: boolean }>`
  position: absolute;
  z-index: 1;
  width: ${PANEL_WIDTH};
  max-width: ${PANEL_WIDTH};
  height: calc(100vh - ${HEADER_HEIGHT});
  background-color: ${({ theme }) => theme.colors.background.dark};
  transition: transform 0.3s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(-100%)')};
`;

export const ContentWrapper = styled.div`
  overflow: hidden;
  height: calc(100% - 60px);
`;

export const StyledButton = styled.button`
  position: absolute;
  top: calc(50% - 32px);
  right: -17px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 17px;
  height: 64px;
  border: none;
  border-radius: 0 6px 6px 0;
  background-color: ${({ theme }) => theme.colors.background.dark};
  cursor: pointer;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
`;

export const DownloadButtonContainer = styled.div`
  margin-left: auto;
`;

export const NoDataMessage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
